import { APP_ROUTES } from '@/routes/routes.type';

export const ROUTES = {
  home: '/',
  login: '/' + APP_ROUTES.LOGIN,
} as const;
